<template>
  <div class="modal fade fixed-right modal-change-manager" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-vertical" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Change Manager</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome :icon="['fal', 'search']"/>
            </span>
          </div>

          <input v-model="debouncedSearch" type="search" class="form-control" placeholder="Search user...">
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-info"
              data-dismiss="modal"
              data-toggle="modal"
              data-target=".modal-new-user-manager">
              <font-awesome :icon="['far', 'plus']" class="mr-2"/> User
            </button>
          </div>
        </div><!-- /.input-group -->

        <div class="modal-body">
          <loading-spinner v-if="fetching"/>

          <no-results v-else-if="noManagers">
            No managers found.
          </no-results>

          <ul v-else class="list-data">
            <li v-for="manager in managers" :key="manager.id">
              <a @click="selectManager(manager)" data-dismiss="modal">
                <p class="name text-truncate">
                  <span>{{ manager.name }}</span>
                </p>
                <p class="text-muted text-truncate">{{ manager.email }}</p>
              </a>
            </li>
          </ul><!-- /.list-data -->
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<style scoped>
  li {
    cursor: pointer;
  }
</style>

<script>
import { managerMethods, managerComputed, placementComputed, programGraduateMethods, graduateComputed } from 'vx/helpers'
import { debounce } from 'lodash'

export default {
  data () {
    return {
      fetching: false,
      search: null
    }
  },

  computed: {
    ...managerComputed,
    ...placementComputed,
    ...graduateComputed,

    debouncedSearch: {
      get () {
        return this.search
      },

      set: debounce(function (value) {
        this.search = value
      }, 1000)
    },

    noManagers () {
      return this.managers.length === 0
    }
  },

  mounted () {
    window.$(this.$el).on('show.bs.modal', this.getInitialManagers)
  },

  watch: {
    async search (search) {
      this.fetching = true

      await this.getManagers({ params: { search, agency: this.placement.agency_id } })

      this.fetching = false
    }
  },

  methods: {
    ...managerMethods,
    ...programGraduateMethods,

    async handleGetNextManagersCallback () {
      let search = this.search
      await this.getManagersForNextPage({ params: { search, agency: this.placement.agency_id } })

      this.$refs.lazy.$emit('reset')
    },

    /**
     * Get the initial list of managers when modal is shown
     */
    getInitialManagers () {
      this.getManagers({ params: { agency: this.placement.agency_id } })
    },

    /**
     * Update existing manager to the the selected one
     */
    async selectManager (manager) {
      await this.updateManagerAssignment({
        manager,
        program: this.graduate.program.id,
        graduate: this.graduate,
        placement: this.placement
      })

      this.$emit('selected', manager)

      this.$noty.success('manager updated.')
    }
  }
}
</script>
